"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var DownloadApp = function DownloadApp(props) {
  return _react["default"].createElement("svg", {
    className: props.className,
    width: "31px",
    height: "30px",
    viewBox: "0 0 31 30",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, _react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("g", {
    transform: "translate(1.000000, 1.000000)"
  }, _react["default"].createElement("path", {
    d: "M13.9998,0 C6.2798,0 -0.0002,6.28 -0.0002,14 C-0.0002,21.72 6.2798,28 13.9998,28 C21.7198,28 27.9998,21.72 27.9998,14 C27.9998,6.28 21.7198,0 13.9998,0",
    fill: "#002272"
  }), _react["default"].createElement("path", {
    className: "hvr-icon-fill",
    d: "M17.3008,22 L10.6998,22 C9.7638,22 9.0008,21.237 9.0008,20.301 L8.9998,7.699 C8.9998,6.763 9.7628,6 10.6988,6 L17.2998,6 C18.2368,6 18.9988,6.763 18.9988,7.699 L18.9998,20.301 C18.9998,21.237 18.2378,22 17.3008,22",
    fill: "#FFFFFF"
  }), _react["default"].createElement("path", {
    d: "M16,8 C16,8.553 15.553,9 15,9 L13,9 C12.447,9 12,8.553 12,8 L11,8 L11.001,20 L17,20 L16.999,8 L16,8 Z",
    fill: "#002272"
  }))));
};

var _default = DownloadApp;
exports["default"] = _default;